<template>
  <div>
    <div></div>
    <div class="container" id="dad">
      <div v-show="active == '1'" class="div-three" id="son">

        <div class="contact-grid" v-for="(item, index) in contacts">
          <div :key="'t-' + index" class="contact-title">{{ item.title }}</div>
          <div :key="'p-' + index" class="contact-phone">{{ item.phone }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: "1",
      contacts: [
        { title: "运营总监 ：赵总监", phone: "联系方式：15639279491" },
        { title: "市场总监： 华总监", phone: "联系方式：13030772911" },
        { title: "学术总监： 李总监", phone: "联系方式：13816164234" },
        { title: "大健康事业部总监：左经理", phone: "联系方式：18608093320" },
        { title: "东北公司经理：许经理", phone: "联系方式：15114601186" },
        { title: "华北公司经理：齐经理", phone: "联系方式：15153155566" },
        { title: "西北公司经理：郝经理", phone: "联系方式：15525133955" },
        { title: "西南公司经理：詹经理", phone: "联系方式：13808197281" },
        { title: "华南公司经理：王经理", phone: "联系方式：18581761556" },
        { title: "华东公司经理：黄经理", phone: "联系方式：18190334044" },
      ],
      content: [
        "业务合作：高总 17313168155",
        "终端合作：邓总 18180307265",
        "学术合作：张总 15608171513",
        "公司地址：四川省成都市新都区大丰街道敬成路99号3栋附409号",
        "百草健康诚邀天下英才合作共赢！",
      ],
    };
  },
  methods: {
    navSelect(index) {
      this.active = index;
    },
  },
};
</script>

<style scoped>
.container {
  width: 920px;
  min-height: 520px;
  margin: auto auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 30px auto;
  /*background: #156098;*/
  background-image: url("/static/image/partner.png");
  background-size: 100% 100%;
  overflow: auto;
}

.content {
  margin-left: 30px;
  font-size: 20px;
  line-height: 50px;
  text-align: left;
  display: flex;
}

.title {
  display: inline-block;
  /* width: 200px; */
}

.info {
  flex: 1;
}

.info .row {
  display: flex;
}

.div-three {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

#dad {
  padding: 0 120px;
  display: flex;
  /* justify-content: center; */
  align-items: center;
}

.el-menu-vertical {
  background-color: transparent !important;
}

/* 两列联系信息网格 */
.contact-grid {
  margin-left: 30px;
  margin-top: 10px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 40px;
  row-gap: 4px;
  align-items: start;
  font-size: 20px;
  line-height: 30px;
}

.contact-title,
.contact-phone {
  width: 300px;
  text-align: left;
  white-space: nowrap;
  font-family: 'Noto Sans SC', system-ui, sans-serif;
}
</style>
